export const filters = {
  filterOrigins: {
    sabana_inversiones_mtbt_detalle_vista: [
      'sabana_inversiones_mtbt_detalle_vista'
    ]
  }
};
